import Box from "@material-ui/core/Box";
import {grey} from "@material-ui/core/colors";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import React, {FC, ReactNode} from "react";
import useStyles from "./styles";

export type MenuItemData = {
  node?: ReactNode;
  divide?: boolean;
  hide?: boolean;
  onClick?: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
  component?: string;
  href?: string;
  disabled?: boolean;
  target?: string;
  rel?: string;
  id?: string;
};

type DotsMenuProps = {
  options: MenuItemData[];
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  onClose?: (e: React.MouseEvent<HTMLElement>) => void;
  id: string;
  disabled?: boolean;
  customIcon?: React.ReactElement;
  style?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
};

const DotsMenu: FC<DotsMenuProps> = ({
  options,
  id,
  disabled,
  customIcon,
  onClick,
  onClose,
  style,
  iconStyle,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    onClose?.(event);
    setAnchorEl(null);
  };

  if (!options.length) {
    return null;
  }

  const MenuComponent = () => {
    if (!open) {
      return null;
    }

    return (
      <Menu
        id={id}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={(e) => handleClose(e as React.MouseEvent<HTMLElement>)}
        classes={{list: classes.menu, paper: classes.paper}}
      >
        {options.map(({node, onClick, id, divide, ...props}, index) => (
          <div key={id || `${index}-${divide}`}>
            <MenuItem
              onClick={(e) => {
                if (open) {
                  onClick && onClick(e);
                  handleClose(e);
                }
              }}
              {...props}
            >
              {node}
            </MenuItem>
            {divide && <Divider className={classes.divider} />}
          </div>
        ))}
      </Menu>
    );
  };

  return (
    <Box style={style}>
      <IconButton
        disabled={disabled}
        aria-label="more"
        aria-controls={id}
        aria-haspopup="true"
        size="medium"
        onClick={handleClick}
        style={{padding: 8}}
      >
        {!customIcon && (
          <MoreVertIcon
            style={{color: disabled ? grey[300] : grey[500], ...iconStyle}}
          />
        )}
        {customIcon && customIcon}
      </IconButton>
      <MenuComponent />
    </Box>
  );
};

export default DotsMenu;
